
    import { defineComponent,reactive,onBeforeMount,computed,onMounted,onUnmounted } from "vue";
    import common from '@/assets/ts/common';
    import { useRouter,useRoute } from 'vue-router';
    import { useModal } from '@/hooks/useModal';
    import { Toast } from 'vant';

    export default defineComponent({
        setup(){
          const { bClick } = useModal();
          const router = useRouter();
          const route = useRoute();
          const data:any = reactive({
            detail:{},
            isLove:false,
            productList:[],
            width:"",
            banner:[],
            scrollToTop:()=>{}
          });

          const height = computed(()=>{
            return (document.body.clientWidth/7 * 6) + 'px';
          });

          onBeforeMount(()=>{
            getData();
            getDataList();
          });

          onMounted(()=>{
            window.addEventListener('scroll', data.scrollToTop)
          });

          onUnmounted(()=>{
            window.removeEventListener('scroll', data.scrollToTop)
          });

          //获取产品列表
          const getDataList = (): void => {
            common.request('post', '/adproduct/getProductAdListInfo')
              .then((res: any) => {
                data.productList = res.data;
              });
          };

          //点赞
          const onClickLove = (id:string) => {
            common.request("post","/adproduct/addProductAdLove",{pid:id})
            .then((res:any)=>{
              data.isLove = true;
              Toast.success(res.message);
            })
          };

          const getData = (id?:string) => {
            Toast.loading({
              message: '加载中...',
              forbidClick: true,
            });
            common.request("post","/adproduct/getProductInfo",{id:id ? id : route.query.id})
            .then((res:any)=>{
              data.detail = res.data;
              data.banner = common.getBanner(data.detail.bannerurl);
              data.details = common.getBanner(data.detail.detailsurl);
              Toast.clear();
            })
            .catch(()=>{
              Toast.clear();
            })
          };

          const goHome = () => {
            router.push("/");
          };

          //跳转详情页
          const goDetail = (id:any):void => {
            /*let ispeed:number = document.documentElement.scrollTop || document.body.scrollTop;
            document.body.scrollTop = (document as any).getElementById("ProductDetail").scrollTop = data.scrollTop + ispeed;*/
            /*let timer = setInterval(() => {
              document.body.scrollTop = (document as any).getElementById("ProductDetail").scrollTop = data.scrollTop + ispeed;
              if (data.scrollTop === 0) {
                clearInterval(timer);
              }
            }, 16);*/
            //getData(id);
            router.push({
              name:"Empty",
              query:{
                id:id,
                name:"ProductDetail"
              },
              replace:true
            });
          };

          return {
            height,
            goDetail,
            data,
            bClick,
            onClickLove,
            goHome
          }
        }
    });
